:host {
  display: block;
  margin: var(--ic-space-xs) var(--ic-space-xs) var(--ic-space-xs) 0;
}

:host .breadcrumb {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: var(--ic-space-xs);
  min-height: var(--ic-space-lg);
}

:host .chevron {
  width: var(--ic-space-lg);
  height: var(--ic-space-lg);
}

:host .chevron svg,
:host(.ic-breadcrumb-monochrome) .chevron svg {
  color: var(--ic-breadcrumb-icon-chevron);
}

:host(:first-child) .chevron {
  display: none;
}

.back-icon svg {
  color: var(--ic-breadcrumb-icon);
}

:host(.ic-breadcrumb-monochrome) .back-icon svg {
  color: var(--ic-breadcrumb-icon-monochrome);
}

:host(.ic-breadcrumb-back) {
  display: flex;
  align-items: center;
}

:host(.ic-breadcrumb-back) .chevron {
  display: none;
}

ic-link {
  --breadcrumb-link-display: inline-flex;
  --breadcrumb-link-align-items: center;
  --breadcrumb-link-gap: var(--ic-space-xs);
}

:host(.ic-breadcrumb-aria-current-page) {
  cursor: text;
}

:host(.ic-breadcrumb-aria-current-page) .current-page-container {
  display: flex;
  align-items: center;
  gap: var(--ic-space-xs);
  color: var(--ic-breadcrumb-text);
}

:host(.ic-breadcrumb-aria-current-page).ic-breadcrumb-monochrome
  .current-page-container {
  color: var(--ic-breadcrumb-text-monochrome);
}

:host(.ic-breadcrumb-aria-current-page) slot {
  pointer-events: none;
}

:host(.collapsed-breadcrumb-wrapper) {
  margin-right: var(--ic-space-xs) !important;
  display: flex;
  align-items: center;
  gap: var(--ic-space-xs);
}

:host(.collapsed-breadcrumb-wrapper) ::slotted(.collapsed-breadcrumb) {
  border: none;
  background-color: transparent;
  color: var(--ic-color-hyperlink-default);
  text-decoration: underline;
  font-weight: var(--ic-font-weight-bold);
  cursor: pointer;
}

:host(.collapsed-breadcrumb-wrapper) ::slotted(.collapsed-breadcrumb:hover),
:host(.collapsed-breadcrumb-wrapper) ::slotted(.collapsed-breadcrumb:focus) {
  outline: var(--ic-hc-focus-outline);
  border-bottom: 0.25rem solid !important;
  margin-bottom: -0.25rem !important;
  text-decoration: none;
}

.hide,
:host(.collapsed-breadcrumb-wrapper) ::slotted(.hide) {
  display: none;
}

.slotted-link-container {
  gap: var(--ic-space-xs);
  display: flex;
}

.slotted-link-container .back-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.slotted-link-container .link-wrapper {
  line-height: 1.5rem;
}

@media (forced-colors: active) {
  .back-icon svg {
    color: currentcolor;
  }
}

@supports (text-underline-offset: 25%) {
  ic-link {
    --breadcrumb-link-display: flex;
  }

  :host(.collapsed-breadcrumb-wrapper) ::slotted(.collapsed-breadcrumb:hover),
  :host(.collapsed-breadcrumb-wrapper) ::slotted(.collapsed-breadcrumb:focus) {
    text-decoration-line: underline;
    text-decoration-thickness: 25%;
    text-underline-offset: 25%;
    border-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
}
